const initialState = {
  counter: 0,
  pagination: {
    totalPage: 1,
    currentPage: 1,
  },
  profiles: [],
  search: "",
  filter: {
    minAge: 18,
    maxAge: 30,
    rasi: [],
    profilesAvailability: false,
  },
  sort: "",
  limit: 10,
};

export default initialState;
